<template>
	<div class="safe-box">
		<div class="top dis-flex">
			<div class="top-box" v-for="(v, k) in dataList" :key="k">
				<div class="dis-flex jus-btn al-center">
					<div class="txt1" style="width: 130px;">{{ v.title }}</div>
					<div v-if="v.type == 1">
						<el-date-picker
						  v-model="date"
						  size="small"
						  style="width: 92%; float: right;"
						  type="daterange"
						  value-format="yyyy-MM-dd"
						  range-separator="至"
						  start-placeholder="开始月份"
						  end-placeholder="结束月份"
						  @change="changeDate"
						>
						</el-date-picker>
					</div>
				</div>
				<div class="money txtC">{{ v.value }}</div>
			</div>
		</div>
		<div class="content dis-flex jus-btn">
			<div class="c-box">
				<div class="c-title">即将到期订单列表</div>
				<el-table
					style="width: 100%;"
					v-loading="loading"
					element-loading-text="加载中"
					:header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
					ref="multipleTable"
					:data="tableData"
					tooltip-effect="dark"
				>
					<el-table-column prop="order_no" label="订单编号"></el-table-column>
					<el-table-column label="客户名称">
						<template slot-scope="scope">
							<span id="">
								{{scope.row.report.name}}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="price" label="订单金额"></el-table-column>
					<el-table-column prop="start_time" label="订单开始时间"></el-table-column>
					<el-table-column prop="end_time" label="订单结束时间"></el-table-column>
				</el-table>
			</div>
			<div class="c-box">
				<div class="c-title">即将到期报备列表</div>
				<el-table
					v-loading="loading2"
					element-loading-text="加载中"
					:header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
					ref="multipleTable"
					:data="reportList"
					tooltip-effect="dark"
					style="width: 100%"
				>
					<el-table-column prop="brand" label="品牌名称"></el-table-column>
					<el-table-column prop="name" label="客户名称"></el-table-column>
					<el-table-column prop="principal" label="责任人"></el-table-column>
					<el-table-column prop="create_time" label="报备时间"></el-table-column>
					<el-table-column prop="expire_time" label="到期时间"></el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			date:'',
			loading:true,
			loading2:true,
			dataList: [
				{ title: '总订单金额(元)', value: '￥0' },
				{ title: '报备客户数(个)', value: 0 },
				{ title: '成单客户数(个)', value: 0 },
				{ title: '在刊客户数(个)', value: 0 },
				{ title: '空缺点位数(个)', value: 0 },
				{ title: '在刊率', value: '0%',type:1 }
			],
			tableData: [],
			reportList:[],
			orderList:[],
			pageObj:{
				
			},
			
		};
	},
	created() {
		this.getMenu()
		this.indexReport()
		this.indexOrder()
		this.calculate()
		this.getPublicRate()
	},
	methods: {
		changeDate(){
			let param = {
				start_time:this.date[0],
				end_time:this.date[1],
			}
			this.getPublicRate(param)
		},
		getMenu(){
			this.$api2.getMenu().then((res)=>{
				if(res.code == 1){
					localStorage.setItem('menu',JSON.stringify(res.data))
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		indexReport(){
			this.$api2.indexReport().then(res => {
				this.loading2 = false;
				if (res.code == 1) {
					this.reportList = res.data;
				}
			})
			.catch(err => {
				this.loading = false;
			});
		},
		getPublicRate(param){
			this.$api2.getPublicRate(param).then(res => {
				// this.loading = false;
				if (res.code == 1) {
					this.dataList[5].value = res.data + '%'
				}
			})
			.catch(err => {
				this.loading = false;
			});
		},
		indexOrder(){
			this.pageObj.is_about = 1
			this.$api2.indexOrder(this.pageObj).then(res => { 
				this.loading = false;
				if (res.code == 1) {
					this.tableData = res.data;
				}
			})
			.catch(err => {
				this.loading = false;
			});
		},
		calculate(){
			this.$api2.calculate().then(res => {
				if (res.code == 1) {
					this.dataList[0].value = '￥'+res.data.total_order_price
					this.dataList[1].value = res.data.total_report_num
					this.dataList[2].value = res.data.pay_order_num
					this.dataList[3].value = res.data.status_order_num
					this.dataList[4].value = res.data.no_status_ids_num
					
				}
			})
			.catch(err => {
				this.loading = false;
			});
		},
	}
};
</script>

<style lang="scss" scoped>
.safe-box {
	// width: 90%;
	padding: 0 10px;
}
.top{
	flex-wrap: wrap;
	justify-content: space-between;
}
.top-box {
	// margin-right: 30px;
	margin-bottom: 20px;
	width: 19vw;
	// height: 80px;
	// width: 13vw;
	// width: 27%;
	padding: 25px 30px;
	background-color: white;
	border-radius: 10px;
	color: #929292;
	.money {
		font-size: 32px;
		margin-top: 10px;
	}
}
.content {
	margin-top: 30px;
	.c-box /deep/ {
		border-radius: 10px;
		padding: 25px 10px;
		background-color: white;
		width: 47%;
		.c-title {
			font-size: 18px;
			margin-bottom: 20px;
		}
		.el-table{
			border: 1px solid #EBEEF5;
		}
	}
}
</style>
